import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

export type ExpectedSource = NonNullable<
  z.infer<typeof schemas.ScenarioQuery>['relevant_sources']
>[number]

export const expectedSourceKey = (s: ExpectedSource): string =>
  typeof s === 'string' ? s : s.source_id

export const expectedSourceLabel = (s: ExpectedSource): string =>
  typeof s === 'string' ? s : s.name
